<script context="module">
	export const routedTabs = {};
</script>

<script>
    import { setContext, onMount } from 'svelte';
    import { replace, location } from 'svelte-spa-router'
    import { getSettingObject } from '../../utils'

    export let persistKey = null;
    export let prefix = '';

    let tabs = [];

    setContext(routedTabs, {
        registerTab: (tab) => {
            tabs.push(tab);
        },
        tabs,
        persistKey,
        prefix
    });

    onMount(() => {
        // On first mount, maybe activate the last visited tab
        // if persistKey is set
        const { defaultPath } = getSettingObject(persistKey)
        if (defaultPath && $location !== defaultPath) {
            replace(defaultPath)
        }
    })

</script>

<div>
	<slot />
</div>
